(() => {
  if (window.curvivProductUI) return;
  window.curvivProductUI = true;
  const colours = {Nero:'#111111',Beige:'#efdab1',Salmone:'#e7aaa0',Marrone:'#854521',Bordeaux:'#8c1728'};
  const enhanced = new WeakMap();
  const dialogs = new WeakSet();
  let sequence = 0;
  const closeMenus = except => document.querySelectorAll('.cv-colour-control').forEach(w => {
    if (w === except) return;
    w.querySelector('.cv-colour-trigger').setAttribute('aria-expanded','false');
    w.querySelector('.cv-colour-menu').hidden = true;
  });
  const dot = value => {
    const e = document.createElement('span');
    e.className = 'cv-colour-dot';
    e.style.backgroundColor = colours[value] || '#cccccc';
    e.setAttribute('aria-hidden','true');
    return e;
  };
  const refresh = () => {
    document.querySelectorAll('kaching-bundle select[data-name="Colore"]').forEach(select => {
      let record = enhanced.get(select);
      if (!record || !record.wrap.isConnected) {
        const wrap = document.createElement('div');
        wrap.className = 'cv-colour-control';
        const trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'cv-colour-trigger';
        trigger.setAttribute('aria-haspopup','listbox');
        trigger.setAttribute('aria-expanded','false');
        trigger.setAttribute('aria-label','Colore');
        const circle = dot(select.value);
        const label = document.createElement('span');
        label.className = 'cv-colour-label';
        trigger.append(circle,label);
        const arrow = document.createElement('span');
        arrow.className = 'cv-colour-arrow';
        arrow.setAttribute('aria-hidden','true');
        trigger.append(arrow);
        const menu = document.createElement('div');
        menu.className = 'cv-colour-menu';
        menu.id = 'cv-colour-menu-' + (++sequence);
        menu.setAttribute('role','listbox');
        menu.setAttribute('aria-label','Colore');
        menu.hidden = true;
        trigger.setAttribute('aria-controls',menu.id);
        wrap.append(trigger,menu);
        select.before(wrap);
        select.classList.add('cv-colour-native');
        select.tabIndex = -1;
        select.setAttribute('aria-hidden','true');
        trigger.addEventListener('click',event => {
          event.stopPropagation();
          const open = trigger.getAttribute('aria-expanded') !== 'true';
          closeMenus(wrap);
          trigger.setAttribute('aria-expanded',String(open));
          menu.hidden = !open;
        });
        trigger.addEventListener('keydown',event => {
          if (!['ArrowDown','ArrowUp'].includes(event.key)) return;
          event.preventDefault();
          closeMenus(wrap);
          menu.hidden = false;
          trigger.setAttribute('aria-expanded','true');
          menu.querySelector('[aria-selected="true"]')?.focus();
        });
        menu.addEventListener('keydown',event => {
          const items = [...menu.querySelectorAll('[role="option"]:not(:disabled)')];
          const current = items.indexOf(document.activeElement);
          if (event.key === 'Escape') {
            event.preventDefault(); closeMenus(); trigger.focus();
          } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            items[(current + (event.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length]?.focus();
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault(); items[event.key === 'Home' ? 0 : items.length - 1]?.focus();
          }
        });
        record = {wrap,trigger,circle,label,menu,signature:''};
        enhanced.set(select,record);
      }
      const options = [...select.options];
      const signature = options.map(o => o.value + ':' + o.text + ':' + o.disabled).join('|');
      if (signature !== record.signature) {
        record.signature = signature;
        record.menu.replaceChildren();
        options.forEach(option => {
          const item = document.createElement('button');
          item.type = 'button';
          item.className = 'cv-colour-option';
          item.setAttribute('role','option');
          item.dataset.value = option.value;
          item.disabled = option.disabled;
          item.append(dot(option.value),document.createTextNode(option.text));
          item.addEventListener('click',event => {
            event.stopPropagation();
            select.value = option.value;
            select.dispatchEvent(new Event('change',{bubbles:true}));
            closeMenus();
            refresh();
            if (record.trigger.isConnected) record.trigger.focus();
          });
          record.menu.append(item);
        });
      }
      const text = select.selectedOptions[0]?.text || 'Seleziona un colore';
      if (record.label.textContent !== text) record.label.textContent = text;
      record.circle.style.backgroundColor = colours[select.value] || '#cccccc';
      record.trigger.disabled = select.disabled;
      record.menu.querySelectorAll('[role="option"]').forEach(item => {
        const value = String(item.dataset.value === select.value);
        if (item.getAttribute('aria-selected') !== value) item.setAttribute('aria-selected',value);
      });
    });
  };
  document.addEventListener('click',event => {
    const open = event.target.closest('[data-cv-size-open]');
    if (open) {
      event.preventDefault();
      event.stopPropagation();
      const dialog = document.getElementById(open.dataset.cvSizeOpen);
      if (!dialog) return;
      if (!dialogs.has(dialog)) {
        dialog.addEventListener('close',() => document.documentElement.classList.remove('cv-size-is-open'));
        dialogs.add(dialog);
      }
      closeMenus();
      dialog.showModal();
      document.documentElement.classList.add('cv-size-is-open');
      return;
    }
    const close = event.target.closest('[data-cv-size-close]');
    if (close) { event.preventDefault(); event.stopPropagation(); close.closest('dialog')?.close(); }
    if (!event.target.closest('.cv-colour-control')) closeMenus();
  },true);
  document.addEventListener('keydown',event => { if (event.key === 'Escape') closeMenus(); });
  document.addEventListener('change',refresh);
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; refresh(); });
  }).observe(document.body,{childList:true,subtree:true});
  refresh();
})();
